import selectRoot from "./root"

export default function selectModels(state) {
  const root = selectRoot(state)
  return root && root.models
}
